module.exports = __webpack_public_path__ + "img/eight2Blue.20a06fbd.jpg";